import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[trimInput]',
  standalone: true
})
export class TrimInputDirective {

  constructor(private el: ElementRef) { }

  @HostListener('blur', ['$event.target.value'])
  onBlur(value: string): void {
    const trimmedValue = value.trim();
    this.el.nativeElement.value = trimmedValue;
  }

}
